import styled from "styled-components";
import { ConteinerBg } from "./Containers";

export const StyledInput = styled.input`
  margin: 5px;
  padding: 5px;
  font-size: 1em;
`;

export const StyledInputWithBorder = styled(StyledInput)`
  border: solid 1px;
  border-color: ${ConteinerBg.black};
  border-radius: 5px;
`;

export const StyledInputWithBorderWithGrow = styled(StyledInputWithBorder)`
  flex-grow: 1;
`;

export const StyledFileInput = styled(StyledInput).attrs(() => ({
  type: "file",
}))`
  font-size: 15px;
`;

export const StyledCheckBox = styled(StyledInputWithBorder).attrs(() => ({
  type: "checkbox",
}))``;
